import React, { useEffect, useState, useContext } from "react";
import axios from "axios";

const GoogleAds = ({
  clientId,
  preload,
  startLoad,
  path,
  fromResult,
  fromLogin,
  fromNav,
}) => {
  // console.log(clientId);

  // const [pubId, setPubId] = useState();

  useEffect(() => {
    let showAd = () => {
      console.log("show Ad preload run");
      window.adBreak({
        type: "browse",
        name: "browse",
      });
    };
    (window.adsbygoogle = window.adsbygoogle || []).push({});
    window.adConfig = function (o) {
      console.log("inside ad config fn")
      window.adsbygoogle.push(o);
    };
    window.adBreak = function (o) {
      console.log("inside adBreak fn")
      window.adsbygoogle.push(o);
    };

    if (preload && !fromLogin) {
      console.log("Playing from starter page");
      window.adConfig({
        preloadAdBreaks: "on",
        onReady: showAd,
      });
    } else if (
      !startLoad &&
      path === "/home" &&
      !fromResult &&
      !fromLogin &&
      !fromNav
    ) {
      console.log("playing from GameList Page");
      window.adConfig({
        preloadAdBreaks: "on",
        onReady: showAd,
      });
    } else {
      console.log("inside else condition");
      showAd();
    }

    // if (!window.adsbygoogle?.loaded) {
    //     window.adConfig({
    //         preloadAdBreaks: 'on',
    //         onReady: showAd
    //     });
    // }
    // else {
    //     showAd();
    // }
    // const scriptLoad = async () => {
    //     let data = await axios.get("https://cdn.unibots.in/quiz/quiz_new.json");
    //     let subdomain = window.location.host.split(".")[0];
    //     let client = data.data[subdomain];
    //     client = client ? client : data.data["default"];
    //     if (client.pubid) {
    //       setPubId(client.pubid);
    //     }
    //   };
    //   scriptLoad();
  }, []);

  let pubId = clientId?.pubId ? clientId.pubId : "1203149545224208";
  return (
    <ins
      className="adsbygoogle w-[350px]"
      style={{ display: "block", width: "350px", height: "250px" }}
      data-ad-client={`ca-pub-${pubId}`}
      data-ad-host="ca-host-pub-1203149545224208"
      data-ad-slot="4537277084"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  );
};

export default GoogleAds;
